module.exports = __webpack_public_path__ + "img/iphone1@2x.57e14acb.png";